import { Subject } from 'rxjs';

export interface UpgradeEvent {
  open: boolean;
  featureName?: string;
  message?: string;
  businessId?: number;
  businessName?: string;
  isOverdue?: boolean;
}

const upgradeSubject = new Subject<UpgradeEvent>();

export const UpgradeService = upgradeSubject.asObservable();

export const showUpgradeModal = (
  featureName?: string,
  message?: string,
  businessId?: number,
  isOverdue?: boolean,
  businessName?: string,
) => {
  upgradeSubject.next({
    open: true,
    featureName,
    message,
    businessId,
    isOverdue,
    businessName,
  });
};

export const hideUpgradeModal = () => {
  upgradeSubject.next({ open: false });
};
